import React from 'react';
import { RefreshCw } from 'lucide-react';

/**
 * Loading Component
 * Displays a loading spinner with optional message
 *
 * @param {Object} props Component props
 * @param {string} props.message Loading message
 * @param {string} props.size Size of the spinner (small, medium, large)
 */
const Loading = ({ message = 'Loading...', size = 'medium' }) => {
  // Determine spinner size
  const sizeMap = {
    small: {
      container: 'p-2',
      icon: 16,
      text: 'text-sm'
    },
    medium: {
      container: 'p-4',
      icon: 24,
      text: 'text-base'
    },
    large: {
      container: 'p-6',
      icon: 32,
      text: 'text-lg'
    }
  };

  const sizeStyle = sizeMap[size] || sizeMap.medium;

  return (
    <div className="flex flex-col items-center justify-center h-full w-full">
      <div className={`flex flex-col items-center ${sizeStyle.container}`}>
        <RefreshCw className="animate-spin text-blue-500 mb-2" size={sizeStyle.icon} />
        <p className={`text-gray-600 ${sizeStyle.text}`}>{message}</p>
      </div>
    </div>
  );
};

export default Loading;
